/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import { LineGraph } from '@gerdau/hefesto-mais-web';
import {
  Column,
  DataProps
} from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';
import { abbreviateNumber } from 'js-abbreviation-number';
import moment from 'moment';
import { IPaidByMonthState } from '../../../../../store/ducks/dashboard/types';
import { formatCurrency } from '../../../../../utils/formatNumbers';
interface IPaymentsByMonthChartProps {
  paidByMonthState: IPaidByMonthState;
  isEmpty: boolean;
}

const PaymentsByMonthChart: React.FC<IPaymentsByMonthChartProps> = ({
  paidByMonthState,
  isEmpty
}) => {
  const PADDING_GRAPH = 15;
  const [chartData, setChartData] = useState<DataProps[]>();

  const columns: Column[] = [
    {
      dataKey: 'total',
      dataKeyTitle: 'Total',
      colors: {
        variant: 'primary-02',
        tone: '500'
      }
    }
  ];

  useEffect(() => {
    if (!chartData) {
      let newChartData: DataProps[] = paidByMonthState.data.map((data) => ({
        date: moment(data.invoicesSummary.date, 'MMM/YYYY').format('MM/YY'),
        total: Number(data.invoicesSummary.totalInvoice),
        customizedTickValue: `${abbreviateNumber(
          Number(data.invoicesSummary.totalInvoice),
          1
        )}`
      }));
      newChartData = [{ date: '' }, ...newChartData, { date: '' }];
      setChartData(newChartData);
    }
  }, [chartData, paidByMonthState.data]);

  return (
    <LineGraph
      columns={columns}
      dataSource={!isEmpty && chartData ? chartData : []}
      XAxisCustomizedTick
      XAxisCustomizedTickLabel="Total"
      XAxisPadding={{ left: PADDING_GRAPH, right: PADDING_GRAPH }}
      lineDataKey={'date'}
      YAxisWidth={60}
      tooltipFormatter={(value: number | string) =>
        `R$ ${formatCurrency(value.toString())}`
      }
    ></LineGraph>
  );
};

export default PaymentsByMonthChart;
